export const uk = {
    adaptive: 'Адаптивный',
    filter: 'Фильтр',
    'sizes-title': 'Размеры'
};
